import { Button } from '@givebutter/primitives/button';
import { PersonalizedLetterStatusBadge } from 'assets/js/pages/engage/letters/PersonalizedLetterStatusBadge';
import { usePersonalizedLettersStore } from 'assets/js/pages/engage/letters/usePersonalizedLettersStore';
import { useSetPersonalizedContact } from 'assets/js/pages/engage/letters/useSetPersonalizedContact';
import { twJoin, twMerge } from 'tailwind-merge';
import { Contact } from 'types/domain';

interface PersonalizedContactButtonProps {
    contact: Contact;
}

const PersonalizedContactButton = (props: PersonalizedContactButtonProps) => {
    const { contact } = props;
    const { currentPersonalizedLetterContact } = usePersonalizedLettersStore();
    const isSelected = contact.id === currentPersonalizedLetterContact?.id;
    const setPersonalizedContact = useSetPersonalizedContact();

    return (
        <Button
            variant="none"
            color={isSelected ? 'primary' : 'neutral'}
            size="sm"
            className={twJoin(
                isSelected && 'bg-blue-50',
                'w-full justify-between border-b border-gray-200 px-8 py-4 hover:bg-gray-100',
            )}
            onClick={() => setPersonalizedContact(contact)}
        >
            <div className={'flex flex-col gap-1 text-start'}>
                <p className={'font-medium'}>{contact.name_display}</p>
                <p className={twMerge(!isSelected && 'text-gray-700')}>
                    {contact.primary_address_formatted}
                </p>
            </div>
            <PersonalizedLetterStatusBadge contact={contact} />
        </Button>
    );
};

export { PersonalizedContactButton };
